import { create } from "zustand";

import { type PieceName, type StructureName } from "src/api";

export type PieceOrStructure =
  | { kind: "piece"; piece: PieceName }
  | { kind: "structure"; structure: StructureName };

// TODO: temporary the engine refuses to select a forgable piece it cannot afford so the
//      forge menu controls its own selection for now for testing out placement until placement
//      goes through to the engine when we start puting in actual game mechanics
export const useSpawnSelection = create<{
  pieceOrStructure: PieceOrStructure | null;
}>(() => ({ pieceOrStructure: null }));
